import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const links = [
  { key: 'home', href: '#home' },
  { key: 'about', href: '#about' },
  { key: 'programs', href: '#programs' },
  { key: 'donate', href: '#donate' },
  { key: 'contact', href: '#contact' },
];

export default function Navbar() {
  const { t, i18n } = useTranslation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const isMs = i18n.language.startsWith('ms');
  const toggleLang = () => i18n.changeLanguage(isMs ? 'en' : 'ms');

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <nav className="flex items-center justify-between h-16 md:h-20 px-4 md:px-6">
        <a href="#home" className="flex items-center gap-2.5 group">
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-full text-lg ${
              scrolled ? 'bg-primary-500 text-background-50' : 'bg-white/15 text-white'
            }`}
          >
            <i className="ri-hand-heart-line"></i>
          </span>
          <span className="flex flex-col leading-tight">
            <span
              className={`font-heading font-bold text-base md:text-lg whitespace-nowrap ${
                scrolled ? 'text-foreground-950' : 'text-white'
              }`}
            >
              Insani Darul Hana
            </span>
            <span
              className={`text-[10px] md:text-[11px] tracking-wide ${
                scrolled ? 'text-foreground-500' : 'text-white/70'
              }`}
            >
              {t('hero.badge')}
            </span>
          </span>
        </a>

        <div className="hidden md:flex items-center gap-1">
          {links.map((link) => (
            <a
              key={link.key}
              href={link.href}
              className={`px-3.5 py-2 rounded-md text-sm font-medium whitespace-nowrap transition-colors cursor-pointer ${
                scrolled
                  ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-100/70'
                  : 'text-white/90 hover:text-white hover:bg-white/10'
              }`}
            >
              {t(`nav.${link.key}`)}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-2 md:gap-3">
          <button
            onClick={toggleLang}
            className={`px-3 py-1.5 rounded-full text-xs font-semibold whitespace-nowrap transition-colors cursor-pointer border ${
              scrolled
                ? 'border-background-300 text-foreground-700 hover:bg-background-100'
                : 'border-white/30 text-white hover:bg-white/10'
            }`}
          >
            {isMs ? 'EN' : 'BM'}
          </button>

          <a
            href="#donate"
            className="hidden sm:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-heart-3-line"></i>
            {t('nav.donate')}
          </a>

          <button
            onClick={() => setOpen(!open)}
            aria-label="Menu"
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md text-xl cursor-pointer ${
              scrolled ? 'text-foreground-900' : 'text-white'
            }`}
          >
            <i className={open ? 'ri-close-line' : 'ri-menu-line'}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50 border-b border-background-200 px-4 pb-4 pt-2">
          {links.map((link) => (
            <a
              key={link.key}
              href={link.href}
              onClick={() => setOpen(false)}
              className="block px-3 py-2.5 rounded-md text-sm font-medium text-foreground-800 hover:bg-primary-100/70 hover:text-primary-700"
            >
              {t(`nav.${link.key}`)}
            </a>
          ))}
          <a
            href="#donate"
            onClick={() => setOpen(false)}
            className="mt-2 flex items-center justify-center gap-1.5 px-4 py-2.5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold"
          >
            <i className="ri-heart-3-line"></i>
            {t('nav.donate')}
          </a>
        </div>
      )}
    </header>
  );
}